import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/recommended_counterparties/',
	},
}
